import utils from './../../utils';
import { PDFLinkPlaceHolder } from "src/app/_constants";

export class EmailContent {
    constructor(_to = "", _url = "", isAutoApprove:boolean = true, mode="" ) {
        let d = new Date();
        this.to = _to;
        // this.subject = `Pending @TransactionType ${d.toLocaleDateString()} ${d.toLocaleTimeString()}`;
        // this.body = `Dear Customer,%0D%0AThis transaction has been sent for approval. Attached below are the pending transaction receipt and customer agreement.%0D%0ATo view the PDF please click the following link: %0D%0A${PDFLinkPlaceHolder}%0D%0A%0D%0APowered by the AGRIS Sales App and provided by Cultura Technologies, LLC. All rights reserved worldwide.`;
        if(isAutoApprove) {
            this.subject =  `Your contract is linked (approved)`;
            this.body = `Dear Customer,%0D%0AThank you for your business, a printable copy of this contract has been saved and approved.%0D%0ATo view or download a copy of this contract PDF please click the following link: *%0D%0A ${PDFLinkPlaceHolder} %0D%0A%0D%0A(*link is available for 30 days.)`;

        }
        else if(mode == "Quote") {
            this.subject =`Your contract is linked (quotation)`;
            this.body = `Dear Customer,%0D%0AThank you for your business, a printable copy of this quote has been saved.%0D%0ATo view or download a copy of this contract PDF please click the following link: *%0D%0A ${PDFLinkPlaceHolder} %0D%0A%0D%0A(*link is available for 30 days.)`;

        }
        else {
            this.subject =`Your contract is linked (pending approval)`;
            this.body = `Dear Customer,%0D%0AThank you for your business, a printable copy of this contract has been saved and is currently pending approval.%0D%0ATo view or download a copy of this contract PDF please click the following link: *%0D%0A ${PDFLinkPlaceHolder} %0D%0A%0D%0A(*link is available for 30 days.)`;
        }

        this.mailTostring = `mailto:${this.to}?subject=${this.subject}&body=${this.body}&cc=${utils.getccEmail()}`;
      
        this.mailTostring = this.mailTostring.replace(PDFLinkPlaceHolder, _url);
    }
    private to: string;
    private body: string;
    private subject: string;
    public mailTostring: string;


    public getEmailSubject(type:string){

    }
}